import { createAction } from '@reduxjs/toolkit'

// Payload: { user, company }. Handled by user/company slices and the root reducer,
// so a switch is a single dispatch instead of several intermediate states.
export const switchCompany = createAction('session/switchCompany')
